import { Col, Row } from 'antd'
import React from 'react'

function WebHonor() {
    return (
        <Row gutter={[16, 16]} style={{ padding: '16px 8px' }}>
            <Col span={24}>
                <img src="./img/home/honor1.png" alt="" style={{ width: '100%', maxWidth: 280, height: 'auto', display: 'block', margin: '0 auto' }} />
            </Col>
        </Row>
    )
}

export default WebHonor
